import styled from 'styled-components';
import * as CSS from 'csstype';
import {
  white,
  accentColorPrim,
  accentColorSecond,
  fontColorPrim,
  fontColorSecond, accentColorTertiary
} from "../../assets/styledAssets/vars";
import {Checkbox, RadioButton, RadioGroup, Switch} from "@progress/kendo-react-inputs";
import {DropDownList, DropDownListProps, MultiSelect} from "@progress/kendo-react-dropdowns";
import {DatePicker} from "@progress/kendo-react-dateinputs";

interface SelectProps {
  primary: boolean
}

interface FieldProps{
  grey: boolean
}


export const baseFieldStyled = `
  border: 1px solid ${accentColorSecond};
  border-radius:1.2rem;
  min-height:4.4rem;
  width:100%;
  transition:.2s;
  position:relative;
  background-image: none;
  background-color: ${white};
`;

export const StyledFormField = styled.div<Partial<CSS.Properties & FieldProps>>`
  ${baseFieldStyled};
  ${props=>props.grey && `background-color:${accentColorTertiary}; border-color:${accentColorTertiary};`}
  input, textarea{
    width:100%;
    border:0;
    box-shadow:none;
    background-color:transparent;
    min-height:4.2rem;
    border-radius:1.2rem;
    color:${fontColorPrim};
    font-size:1.4rem;
    padding:1.2rem 1.6rem;
    resize: vertical;
    &.has-postfix{padding-right:4rem}
    + svg, + div{
        position: absolute;
        right:1.2rem;
        bottom:50%;
        transform: translateY(50%);
    }
    &:hover,
    &:focus{
      outline:none;
    }
  }
  &:hover,
  &:focus{
    border-color: ${accentColorPrim};
    outline:none;
  }
`;

export const StyledMultiSelect = styled(MultiSelect)`
  min-width:18rem;
  .k-multiselect-wrap{
    ${baseFieldStyled}
    padding:.2rem;
    .k-button{
      color: ${fontColorPrim};
      background-color: ${accentColorSecond};
      background-image:none;
      border:0;
      border-radius:.8rem;
      span{
        color: ${fontColorPrim};        
      }
      .k-select{
        .k-icon{
          color: ${fontColorPrim}
        }
      }
    }
    &:hover,
    &:focus{
      border-color: ${accentColorPrim};
      outline:none;
    }
  }
`;

export const StyledLabel = styled.label`
  color: ${fontColorSecond};
  font-size:1.4rem;
  padding-bottom:.5rem;
  line-height:1;
  margin-left:1rem;
  display:flex;
  align-items:center;
`;

export const StyledDropDownList = styled(DropDownList)<DropDownListProps>`
    width:100%;
    .k-input{
        height:auto;
        font-size:1.4rem;
        padding: 1.2rem 1.6rem;
    }
    .k-dropdown-wrap{
        ${baseFieldStyled}
        &:hover,
        &:focus{
            border-color: ${accentColorPrim};
            color: ${fontColorPrim};
            background-color: ${white};
            background-image: none;
            box-shadow:none;
            &[aria-expanded='true']{
              border-bottom:0;
              border-bottom-left-radius:0;
              border-bottom-right-radius:0;
            }
        }
    }
`;

export const StyledDropDownListTransparent = styled(DropDownList) < Partial < CSS.Properties & SelectProps >> `
    width:18rem;
    border:0;
    background-color:transparent;
    background-image:none;
    &:hover{
        border-color: transparent;
    }
    .k-input{
        height:auto;
        font-size:2.4rem;
        font-weight:bold;
        padding: .2rem 1.6rem;
        color: #000;
        min-height:4rem;
    }
    .k-dropdown-wrap{
        background-color:transparent;
        background-image:none;
        border:0;
        &:hover,
        &:focus{
            border-color: transparent;
            color: #000;
            background-color: transparent;
            background-image: none;
            box-shadow:none;
        }
    }
`;

export const StyledDropDownListTransparentPrimary = styled(DropDownList) < Partial < CSS.Properties & SelectProps >> `
    width:18rem;
    border:0;
    background-color:transparent;
    background-image:none;
    &:hover{
        border-color: transparent;
    }
    .k-input{
        height:auto;
        font-size:2.4rem;
        font-weight:bold;
        padding:.2rem 1.6rem;
        color: ${accentColorPrim};
        min-height:4rem;
    }
    .k-dropdown-wrap{
        background-color:transparent;
        background-image:none;
        border:0;
        &:hover,
        &:focus{
            border-color: transparent;
            color: ${accentColorPrim};
            background-color: transparent;
            background-image: none;
            box-shadow:none;
        }
    }
`;

export const StyledRadioButton = styled(RadioButton)`
    border-color: ${accentColorSecond};
    width: 1.8rem;
    height:1.8rem;
    &:checked{
        border-color: ${accentColorPrim};
        background-color: ${accentColorPrim};
        &:focus{
            border-color: ${accentColorPrim};
            box-shadow: 0 0 .5rem 0 ${accentColorPrim};
        }
    }
    + .k-radio-label{
        margin-left:.7rem;
    }
`;

export const StyledRadioGroup = styled(RadioGroup)`
    display:flex;
    align-items:center;
    flex-grow:1;
    .k-radio-item{
      padding:0;
      width:auto;
      display:flex;
      align-items:center;
      &:not(:last-child){
        margin-right:1rem;
      }
      input{
        border-color: ${accentColorSecond};
        width: 1.8rem;
        height:1.8rem;
        &:checked{
          border-color: ${accentColorPrim};
          background-color: ${accentColorPrim};
          &:focus{
              border-color: ${accentColorPrim};
              box-shadow: 0 0 .5rem 0 ${accentColorPrim};
          }
      }
      }
    }
`;

export const StyledCheckBox = styled(Checkbox)`
   .k-checkbox{
    border-color: ${accentColorSecond};
    width: 1.8rem;
    height:1.8rem;
        &:checked,
        &:checked:focus{
            border-color: ${accentColorPrim};
            background-color: ${accentColorPrim};
            &:focus{
                border-color: ${accentColorPrim};
                box-shadow: 0 0 .5rem 0 ${accentColorPrim};
            }
        }
        &:focus{
          border-color: ${accentColorPrim};
          box-shadow: 0 0 .5rem 0 ${accentColorPrim};
        }
    }
    + .k-checkbox-label{
        margin-left:.7rem;
    }
`;

const calendarIcon = `<svg width='16' height='16' viewBox='0 0 35 35' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M9.24854 8.25073H26.7485' stroke='rgb(171, 178, 191)' strokeWidth='3' strokeLinecap='round' strokeLinejoin='round'/><path d='M30.25 1.52417H5.75C3.81625 1.52417 2.25 3.09042 2.25 5.02417V29.2512C2.25 31.1849 3.81625 32.7512 5.75 32.7512H30.25C32.1838 32.7512 33.75 31.1849 33.75 29.2512V5.02417C33.75 3.09042 32.1838 1.52417 30.25 1.52417V1.52417Z' stroke='rgb(171, 178, 191)' strokeWidth='3' strokeLinecap='round' strokeLinejoin='round'/><path d='M21.2935 25.7495H26.9215' stroke='rgb(171, 178, 191)' strokeWidth='3' strokeLinecap='round' strokeLinejoin='round'/><path d='M24.107 25.7495V15.2495L21.041 18.0215' stroke='rgb(171, 178, 191)' strokeWidth='3' strokeLinecap='round' strokeLinejoin='round'/><path d='M10.125 17.2655C10.4593 16.1105 11.4795 15.2495 12.7412 15.2495C14.2708 15.2495 15.5115 16.4885 15.5115 18.0198C15.5115 19.3883 14.4003 20.4995 13.0318 20.4995C14.4003 20.4995 15.5115 21.6108 15.5115 22.9793C15.5115 24.5088 14.2725 25.7495 12.7412 25.7495C11.4795 25.7495 10.4593 24.8885 10.125 23.7335' stroke='rgb(171, 178, 191)' strokeWidth='3' strokeLinecap='round' strokeLinejoin='round'/></svg>`;

export const StyledDatePicker = styled(DatePicker)`
  width:100%;
  .k-picker-wrap{
    ${baseFieldStyled}  
    .k-dateinput-wrap{
      border-radius:1.2rem;
      .k-input{
        width:100%;
        border:0;
        height:100%;
        box-shadow:none;
        min-height:4 .8rem;
        border-radius:1.2rem;
        color:${fontColorPrim};
        font-size:1.4rem;
        padding:1.2rem 1.6rem;
        &.has-postfix{padding-right:4rem}
        &:hover,
        &:focus{
          outline:none;
        }
      }
    }
    .k-select{
        background-image:none;
        background-color: transparent;
        width: 4.4rem;
        .k-icon{
          color:${fontColorSecond};
          &:before{
            content: url("data:image/svg+xml; utf8, ${calendarIcon}");
          }
        }
      }
    &:hover,
    &:focus{
      border-color: ${accentColorPrim};
      outline:none;
    }
  }
`;

export const StyledSwitch = styled(Switch)`
  transition:.2s;
  &.k-switch-on {
    .k-switch-container{
      background-color: ${accentColorPrim};
    }
    .k-switch-handle{
      left:0;
      right:2.6rem;
    }
  }
  .k-switch-container{
    transition:.2s;
    height:3.4rem;
    padding:.4rem;
    box-shadow:none;
    background-color: ${white};
  }
  .k-switch-label-on,
  .k-switch-label-off{
    display:none;
  }
  .k-switch-handle,
  &.k-switch-off.k-switch-handle{
    left:2.6rem;
    right:0;
  }
  .k-switch-handle{
    width:2.6rem;
    height:2.6rem;
    border:0;
  }
  
  &:hover .k-switch-container,
  &.k-state-hover .k-switch-container{
    box-shadow:none;
    box-shadow:inset 0 0 0 1px ${accentColorPrim};
  }
`;
